export const wardRoutes = [
    {
        name: "ward-list",
        path: "/ward/:wardId",
        component: () => import("@/app/wards/WardList"),
        props: true
    },
    {
        name: "ward-contact",
        path: "/ward/:wardId/contact/:contactId?",
        component: () => import("@/app/wards/WardContact"),
        props: true
    },
    {
        name: "ward-contact-notes",
        path: "/ward/:wardId/contact/:contactId/notes",
        component: () => import("@/app/wards/WardContactNotes"),
        props: true
    },
    {
        name: "ward-notification",
        path: "/ward/:wardId/notification",
        component: () => import("@/app/wards/WardNotification"),
        props: true
    },
    {
        name: "ward-detail",
        path: "/ward/:wardId/detail",
        component: () => import("@/app/wards/Ward.vue"),
        props:true
    },
    {
        name: "ward-organizations",
        path: "/ward/:wardId/organizations",
        component: () => import("@/app/wards/WardOrganizations"),
        props:true
    },
    {
        name: "ward-organization",
        path: "/ward/:wardId/organization/:orgCode?",
        component: () => import("@/app/wards/WardOrganization"),
        props:true
    },
    {
        name: "ward-import-utility",
        path: "/ward/:wardId/contact-import",
        component: () => import ("@/app/wards/WardImportUtility"),
        props:true
    },
    {
        name: "ward-bulk-import-list",
        path: "/ward/:wardId/contact-import-list",
        component: () => import ("@/app/wards/WardImportRequestList"),
        props:true
    },
    {
        name: "ward-bulk-import-detail",
        path: "/ward/:wardId/contact-import/:importRequestId",
        component: () => import ("@/app/wards/WardImportRequestDetail"),
        props:true

    },
    {
      name: "ward-user-list",
      path: "/ward/:wardId/users",
      component: ()=>import("@/app/wards/wardUserList"),
      props: true
    },
    {
      name: "ward-user-detail",
      path: "/ward/:wardId/users/:userName?",
      component: () => import("@/app/wards/wardUser"),
      props: true
    },
    {
        name: "change-credentials-ward",
        path: "/change-credentials-ward",
        component: () => import("@/app/wards/wardUserPasswordReset"),
        props: true
    },
    {
        name: "ward-contact-signup",
        path: "/ward/:wardId/public/signup/:securityKey",
        component: () => import("@/app/wards/wardContactSignUp"),
        props: true
    },
    {
        name: "ward-twilio-setup",
        path:"/ward/:wardId/twilio/setup",
        component: () => import("@/app/wards/wardTwilioSetUp"),
        props: true
    }
]
